module.exports = __webpack_public_path__ + "static/media/tinywow_2590Alnus_colored_55475738.5e088f1c.jpg";